<template>
  <div class='h-outTabs'>
    <ejs-tab id='trackTaskTab' ref='tabRef' :showCloseButton='true' :removing='changeTab' :removed='removeTabFunc' :selecting='tabSelect'　heightAdjustMode='Auto'>
      <e-tabitems>
        <e-tabitem :header='tab.headerText' content='#trackTable' cssClass='h-tab-noClose'></e-tabitem>
      </e-tabitems>
    </ejs-tab>
    <div id='trackTable' class='h100vh-140'>
      <TrackTableMenu @methodEnum='methodEnum' @keywords='changeKeywords'></TrackTableMenu>
      <TrackTable :trackType='trackType' ref="trackTable" @addTab='addTab' @downloadTab='downloadTab'></TrackTable>
    </div>
  </div>
</template>
<script>
import TrackTableMenu from './TrackTableMenu';
import TrackTable from './TrackTable';
import ImportTrackList from '../importTrack/ImportTrackList';
import DownloadFile from './DownloadFile';
import bus from '../bus.js';
import { EventBus } from '../../../plugins/eventBus';
import socketInstance from '../../../plugins/stompSock';

export default {
  name: 'TrackTaskList',
  components: {
    TrackTableMenu,
    TrackTable
  },
  props: ['trackType'],
  data() {
    return {
      locale: localStorage.getItem('locale'),
      tab: {
        headerText: { text: this.$t('Track.taskList') }
      },
      tabList: [this.$t('Track.taskList')],
      tabListVallue: [this.$t('Track.taskList')]
    };
  },
  methods: {
    tabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    changeKeywords(args) {
      this.$refs.trackTable.queryConditions.keywords = args;
      this.$refs.trackTable.page.pageNo = "1";
      this.$refs.trackTable.getTrackListData();
    },
    addTab(args) {
      // 在父窗口增加一个TAB页
      const title = args[0].taskName;
      const item = {
        header: { text: title },
        content() {
          return {
            template: ImportTrackList
          };
        }
      };
      localStorage.setItem('trackNowTab', JSON.stringify({
        name: title,
        value: args,
        type: 'missionTab'
      }));
      this.addTabFunc(title, item, args);
    },
    downloadTab(args) {
      const title = this.$t('Track.download');
      const item = {
        header: { text: title },
        content() {
          return {
            template: DownloadFile
          };
        }
      };
      this.addTabFunc(title, item, args);
    },
    downloadTableTab(args) {
      const title = args[0].fileName;
      const item = {
        header: { text: title },
        content() {
          return {
            template: ImportTrackList
          };
        }
      };
      localStorage.setItem('trackNowTab', JSON.stringify({
        name: title,
        value: args,
        type: 'Import'
      }));
      this.addTabFunc(title, item, args);
    },
    addTabFunc(title, item, args) {
      const tabObj = this.$refs.tabRef.ej2Instances;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      const index = this.tabList.findIndex(v => v === title);
      if (index > 0) {
        tabObj.select(index);
      } else if (title !== this.$t('Track.download') && title.indexOf('.json') === -1) {
        const missionTab = this.tabList.filter(v => v !== this.$t('Track.download') && v.indexOf('.json') === -1);
        if (missionTab.length > 5) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.maximumMissionNumber')});
        } else {
          this.tabList.push(title);
          this.tabListVallue.push(args);
          tabObj.addTab([item], itemLength);
          tabObj.select(itemLength);
        }
      } else {
        this.tabList.push(title);
        this.tabListVallue.push(args);
        tabObj.addTab([item], itemLength);
        tabObj.select(itemLength);
      }
      bus.$emit(title, args);
    },
    removeTabFunc(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      bus.$off(this.tabList[index]);
      if (this.tabList[index] !== this.$t('Track.download') && this.tabList[index].indexOf('.json') === -1) {
        // 只有跟踪页面关闭websocket
        socketInstance.stopReceiveTopicMsg(`track_${this.tabListVallue[index][0].taskId}`, '/user/#/TrackReportServer');
      }
      this.tabList.splice(index, 1);
      this.tabListVallue.splice(index, 1);
    },
    changeTab(args) {
      const index = this.tabList.findIndex(v => v === args.removedItem.textContent);
      const tabObj = this.$refs.tabRef.ej2Instances;
      const selecteIdndex = tabObj.selectedItem;
      const itemLength = document.querySelectorAll('#trackTaskTab .e-tab-header .e-toolbar-item').length;
      if (index == selecteIdndex) {
        if (index == (itemLength - 1)) {
          tabObj.select(itemLength - 2);
        } else {
          tabObj.select(itemLength - 1);
        }
      }
    },
    methodEnum(opcode) {
      switch (opcode) {
        case 'refresh':
          this.$refs.trackTable.queryConditions.keywords = '';
          this.$refs.trackTable.page.pageNo = "1";
          this.$refs.trackTable.getTrackListData();
          break;
        case 'add':
          this.$refs.trackTable.addTrackPage();
          break;
        case 'update':
          this.$refs.trackTable.updateTrackPage();
          break;
        case 'active':
          this.$refs.trackTable.activeTrackPage();
          break;
        case 'hangup':
          this.$refs.trackTable.hangupTrackPage();
          break;
        case 'finish':
          this.$refs.trackTable.finishTrackPage();
          break;
        case 'delete':
          this.$refs.trackTable.deleteTrackPage();
          break;
        case 'detail':
          this.$refs.trackTable.detailTrackPage();
          break;
        case 'mission':
          this.$refs.trackTable.missionTrackPage();
          break;
        case 'download':
          this.$refs.trackTable.downloadTrackPage();
          break;
        default:
      }
    }
  },
  mounted() {
    bus.$on('downloadTableTab', (args) => {
      console.log(1, args);
      this.downloadTableTab(args);
    });
  },
  beforeDestroy() {
    bus.$off('downloadTableTab');
  }
};
</script>
